/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Liability_Analysis_Field_Accident_DynamicsInputs */

const en_liability_analysis_field_accident_dynamics = /** @type {(inputs: Liability_Analysis_Field_Accident_DynamicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accident Dynamics`)
};

const pt_br2_liability_analysis_field_accident_dynamics = /** @type {(inputs: Liability_Analysis_Field_Accident_DynamicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dinâmica do sinistro`)
};

/**
* | output |
* | --- |
* | "Accident Dynamics" |
*
* @param {Liability_Analysis_Field_Accident_DynamicsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const liability_analysis_field_accident_dynamics = /** @type {((inputs?: Liability_Analysis_Field_Accident_DynamicsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Liability_Analysis_Field_Accident_DynamicsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_liability_analysis_field_accident_dynamics(inputs)
	return pt_br2_liability_analysis_field_accident_dynamics(inputs)
});